import * as React from 'react';
import { Outlet } from "react-router-dom";
import Container from '@mui/material/Container';

const Runpod = () => {
    return <Container component="main" maxWidth="xs">
            <h1>Runpod</h1>
            <Outlet />
        </Container>
};

export default Runpod;